// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-radio__label {\n  font-size: 0.34667rem;\n  font-weight: 500;\n  color: #939393;\n}\n", ""]);
// Exports
module.exports = exports;
